const StatsAtGlanceCard = ({
  background,
  title,
  titleColor,
  value,
  valueColor,
  icon,
  iconBg,
}) => {
  return (
    <div
      className={`flex items-center space-x-3 py-8 px-4 rounded-lg ${
        background
          ? `${background}`
          : "bg-white border border-gray-200 hover:shadow-sm"
      }`}
    >
      <div className={`p-3 rounded-full ${iconBg ? iconBg : "bg-gray-100"}`}>
        {icon}
      </div>
      <div>
        <div
          className={`text-xs ${
            titleColor ? titleColor : "text-gray-900"
          } uppercase tracking-wide font-medium`}
        >
          {title}
        </div>
        <div
          className={`text-lg font-bold ${
            valueColor ? valueColor : "text-gray-900"
          }`}
        >
          {value}
        </div>
      </div>
    </div>
  );
};
export default StatsAtGlanceCard;
